export default {
    translation: {
      // header
      SelectLanguage: "Изберете Език",
      Discover: "Открийте",
      WhyQriend: "Защо QRiend?",
      LeaveMark: "Оставете Своя Отпечатък",
      InstallNow: "Изтеглете Сега",
      Login: "Влизане",
      Register: "Регистрация",
      LogOut: "Излизане",
  
      // footer
      HomePage: "Начална Страница",
      QriendDescFooter:
        "Откривайте нови приятелства в социални среди, запознавайте се безопасно и модерно!",
      Pages: "Страници",
      PrivacyAndSecurity: "Поверителност и Сигурност",
      QriendTeam: "Нашият Екип",
      PrivacyPolicy: "Политика за Поверителност",
      TermsOfUse: "Условия за Използване",
      DataSecurity: "Сигурност на Данни",
      CookiePolicy: "Политика за Бисквитки",
      AccountSecurity: "Сигурност на Профила",
      LegalConsentAndDisclosureText: "Правно Съгласие и Информационен Текст",
      ChildSafetyPolicy: "Политика за Безопасност на Деца",
      PrivacySettingsGuide: "Политика за Настройки на Поверителност",
      SuitableForAllDevices: "Съвместимо с всички устройства",
      DownloadNowFooter: "Изтеглете сега, разширете социалната си мрежа!",
  
      // delete request
      DeleteRequestTitle: "Заявка за изтриване на акаунт",
      DeleteAccountQuestion: "Искате ли да изтриете акаунта си?",
      Username: "Потребителско име",
      Password: "Парола",
      DeleteReason: "Защо искате да изтриете акаунта си?",
      UsernamePlaceholder: "Въведете потребителското си име",
      PasswordPlaceholder: "Въведете паролата си",
      ReasonPlaceholder: "Обяснете защо искате да изтриете акаунта си...",
      SubmitDeleteRequest: "Изпрати заявка за изтриване",
      Warning: "Предупреждение",
      WarningMessage: "Изтриването на акаунта не може да бъде отменено. Всички ваши данни ще бъдат изтрити за постоянно.",
      RequestSubmittedSuccessfully: "Заявката е изпратена успешно",
      RequestSubmittedMessage: "Заявката ви за изтриване на акаунт е получена. Ще се свържем с вас възможно най-скоро.",
      SendNewRequest: "Изпрати нова заявка",
      UsernameRequired: "Потребителското име е задължително",
      PasswordRequired: "Паролата е задължителна",
      ReasonRequired: "Причината за изтриване на акаунта е задължителна",

      // register page
      createAccount: "Създаване на акаунт",
      createAccountDesc: "Регистрирайте се сега и започнете да се запознавате с нови хора!",
      firstname: "Име",
      lastname: "Фамилия",
      username: "Потребителско име",
      email: "Имейл",
      password: "Парола",
      gender: "Пол",
      male: "Мъж",
      female: "Жена",
      noGender: "Предпочитам да не казвам",
      registerMain: "Регистрация",
      registerDesc: "Вече имате акаунт?",
      registerLogin: "Вход",
      kvkkConsent: "Съгласен съм с KVKK и споразуменията за поверителност",
      kvkkConsentRequired: "Трябва да се съгласите с KVKK и споразуменията за поверителност",
      privacyPolicy: "Политика за поверителност",
      termsOfUse: "Условия за ползване",

      // Landing Qriend Nedir?
      WhatIsQriend: "Какво е QRiend?",
      WhatIsQriendDesc:
        "Позволява ви да се запознаете с хора, които са на същото място с QR код технология. Предлага модерна и безопасна платформа за запознанства с нови хора в социални места като барове, кафенета, ресторанти.",
      RealProfile: "Реален Профил",
      RealProfileDesc:
        "Взаимодействате само с проверени реални потребители.",
      InstantMeetingOpportunity: "Моментална Възможност за Запознанство",
      InstantMeetingOpportunityDesc:
        "Можете моментално да се запознаете с някого, когото виждате в мястото, като изпратите съобщение.",
      VenueChats: "Чатове на Места",
      VenueChatsDesc:
        "QRiend предлага възможност за цифрово социализиране в мястото, където се намирате.",
  
      // Landing Nasıl Tanışılır?
      HowtoMeet: "Как да се Запознаете?",
      HowtoMeetDesc:
        "Благодарение на нашето приложение, запознаването с хора на мястото, където се намирате, в реално време вече е много лесно! Ето как да го използвате стъпка по стъпка;",
      EntryandConnectiontotheSpace: "Влизане и Свързване към Мястото",
      EntryandConnectiontotheSpaceDesc: "Сканирайте QR кода с телефона си",
      EntryandConnectiontotheSpaceDesc2:
        "Влезте в приложението и се присъедините към мрежата на мястото",
      InSituExploration: "Изследване на Мястото",
      InSituExplorationDesc: "Вижте други потребители, които се намират на мястото в този момент",
      InSituExplorationDesc2: "Разгледайте профили, които ви изглеждат интересни",
      CommunicationInitiation: "Започване на Комуникация",
      CommunicationInitiationDesc: "Изпратете съобщение на хора, които привлякоха вниманието ви",
      CommunicationInitiationDesc2:
        "Лесно общувайте с някого, с когото се срещнахте с поглед",
      CommunicationInitiationDesc3: "Влезте в групов чат на вашето местоположение",
      SafeSocialization: "Безопасно Социализиране",
      SafeSocializationDesc: "Запознайте се чрез обмен на съобщения",
      SafeSocializationDesc2:
        "Можете да контролирате или прекратите разговора по всяко време",
      SafeSocializationDesc3:
        "Продължете да се запознавате с нови хора по приятен и безопасен начин",
  
      //   Uygulamayı İndir Bölümü
      DownloadApp: "ИЗТЕГЛЕТЕ ПРИЛОЖЕНИЕТО &",
      DownloadApp2: "ЗАПОЧНЕТЕ ДА ОТКРИВАТЕ!",
      DownloadAppDesc: "В App Store и Google Play!",
      DownloadAppDesc2: "Изтеглете безплатно,",
      DownloadAppDesc3: "открийте премиум функции.",
  
      // discover
      DiscoverTitle:
        "Иновативна и Социална Платформа, Улесняваща Реални Срещи",
      DiscoverDesc:
        "Отегчени ли сте от безкрайни разговори? Не бихте ли искали да знаете, че се намирате на същото място с хора, с които искате да се запознаете в реалния живот? Точно затова нашето приложение е различно!",
      DiscoverEp2:
        "Готови ли сте да получите възможността да се запознаете с реални хора на същото място, потвърждавайки присъствието си с QR код технология в нашите партньорски места?",
      DiscoverEp2Dot: "Проследяване на Приятелство",
      DiscoverEp2DotDesc:
        "Следвайте профили, които харесвате, и открийте местата, които предпочитат. Получете възможност за запознанство с нови места и нови хора.",
      DiscoverEp3Dot: "Харесвания на Профили и Места",
      DiscoverEp3DotDesc:
        "Запознайте се с нови хора чрез профили и места, които харесвате, открийте любими места.",
      DiscoverEp4Dot: "Запознанство на Място",
      DiscoverEp4DotDesc:
        "За разлика от обичайните приложения за запознанства, при нас всичко е реално! Можете да видите, че се намирате на същото място с някого, който харесвате, и веднага да се запознаете.",
      SwiperText: "Удобен Интерфейс",
  
      SafetyMeet: "По-безопасни и Забавни Запознанства",
      RealTimeInteraction: "Взаимодействие в Реално Време",
      RealTimeInteractionDesc:
        "Вместо да се губите във виртуалния свят, запознайте се с хора, които наистина се намират на същото място сега",
      RealTimeInteractionDesc2:
        "Кой е в любимото ви кафене? Вижте моментално и не пропускайте възможността за запознанство",
      RealTimeInteractionDesc3:
        "Благодарение на нашата QR код технология, лесно потвърдете мястото, където се намирате",
      SecureAndVerifiedEnvironment: "Безопасна и Проверена Среда",
      SecureAndVerifiedEnvironmentDesc: "Социализирайте се в нашите партньорски места",
      SecureAndVerifiedEnvironmentDesc2:
        "Рискът от фалшиви профили е минимален благодарение на реалната проверка на местоположението",
      SecureAndVerifiedEnvironmentDesc3:
        "Открийте и споделете любими места",
      BenefitsForBusinesses: "Предимства за Бизнеса",
      BenefitsForBusinessesDesc: "Увеличете потока от клиенти",
      BenefitsForBusinessesDesc2: "Създайте среда с високо социално взаимодействие",
  
      // leave-mark
      LeaveMark: "Оставете Своя Отпечатък",
      LeaveMarkTitle:
        "Оставете Своя Отпечатък: Разширете Социалното си Преживяване, Създавайте Връзки на Събития",
      LeaveMarkDesc:
        "Функцията 'Оставете Своя Отпечатък' на QRiend ви позволява да разширите социалното си преживяване на концерти, фестивали, конференции и много други събития. Вече можете да се запознавате с нови хора не само в места, но и на всяко събитие, което посещавате.",
      How2Use: "Как Работи?",
      How2UseDot1: "Участие в Събитието",
      How2UseDot1Desc:
        "Идете на концерт, фестивал, конференция или всяко събитие",
      How2UseDot1Desc2: "Сканирайте специалния QRiend QR код в зоната на събитието",
      How2UseDot1Desc3: "Моментално се свържете към чата на събитието",
      How2UseDot2: "Откриване на Участници в Събитието",
      How2UseDot2Desc:
        "Прегледайте други QRiend потребители, участващи в същото събитие",
      How2UseDot2Desc2:
        "Следете в реално време колко души са активни в чата на събитието",
      How2UseDot2Desc3: "Намерете хора с общи интереси",
      How2UseDot3: "Специални Взаимодействия",
      How2UseDot3Desc:
        "Можете да изпращате специални емоджита на участници, които привлякоха вниманието ви",
      How2UseDot3Desc2:
        "Изпратените емоджита се виждат в целия чат като 'Потребител A изпрати емоджи сърце на Потребител B'",
      How2UseDot3Desc3:
        "Изпращането на емоджита е премиум функция и прави запознаването на събития по-забавно",
      WhereCanIUseIt: "Къде Мога да го Използвам?",
      WhereCanIUseItDesc:
        "Най-лесният начин да се запознаете с нови хора в различни среди от кафенета до концерти, от фестивали до ресторанти.",
      WhereCanIUseItDot1: "Оставете Своя Отпечатък на Концерти",
      WhereCanIUseItDot1Desc:
        "Напишете нещо, което ще остави вашия отпечатък на концерта, който посещавате.",
      WhereCanIUseItDot2: "Оставете Своя Отпечатък в Кафенета",
      WhereCanIUseItDot2Desc:
        "Възможност за социализиране в широки приятелски кръгове в кафенета или пъбове",
      WhereCanIUseItDot3: "Използване в Барове и Нощни Клубове",
      WhereCanIUseItDot3Desc:
        "Социализиране в нощния живот, тематични вечери и възможности за безопасни запознанства",
      DownloadApp: "Изтеглете Мобилното Приложение и Оставете Своя Отпечатък",
  
      // downloadPage
      DownloadNowNew: "Изтеглете Сега и Започнете",
      DownloadNowNew2: "да се Запознавате с Нови",
      DownloadNowNew3: "Хора!",
      DownloadNowDesc:
        "На всяко място, където отидете, запознайте се с нови хора само с един QR!",
      SupportPlatforms: "Поддържани Платформи и Устройства",
      SupportPlatformsDesc: "Възможност за Достъп от Навсякъде",
      SupportPlatformsDesc2: "Мобилни Устройства",
      SupportPlatformsDescDot:
        "iOS приложение (оптимизирано за iPhone и iPad)",
      SupportPlatformsDescDot2:
        "Android приложение (Всички Android телефони и таблети)",
  
      // login ve register
      welcome: "Добре дошли",
      welcomeDesc:
        "Липсвахте ни! Моля, влезте в профила си, за да надгоните пропуснатото.",
      email: "E-Mail",
      password: "Парола",
      forgotPassword: "Забравихте паролата си?",
      login: "Влизане",
      registerMain: "Регистрация",
      loginDesc: "Нямате профил още? Веднага",
      loginReg: "се регистрирайте",
      createAccount: "Създаване на Профил",
      createAccountDesc: "Регистрирайте се сега, започнете да създавате нови приятелства.",
      firstname: "Име",
      lastname: "Фамилия",
      username: "Потребителско Име",
      gender: "Пол",
      password: "Парола (Поне 6 символа)",
      register: "Регистрация",
      registerDesc: "Имате профил? Веднага",
      registerLogin: "Влезте",
      rememberMe: "Запомни ме",
      male: "Мъж",
      female: "Жена",
      noGender: "Не искам да посоча пол",
  
      // Şifre Sıfırlama - forgotPassword.js
      resetPassword: "Обновете Паролата си",
      resetPasswordDesc: "Моля, въведете имейл адреса си, за да заявите нулиране на парола.",
      emailPlaceholder: "...@qriend.app",
      sending: "Изпраща се...",
      send: "Изпрати",
      userNotFoundError: "Не е намерен потребител с този имейл адрес.",
      generalError: "Възникна грешка, моля опитайте отново.",
      checkSpamFolder: "*Не забравяйте да проверите папката за спам.",
  
      // Şifre Sıfırlama Onay - forgotPasswordConfirm.js
      passwordReset: "Нулиране на Парола",
      passwordResetDesc: "Въведете 6-цифрения код, изпратен на имейла ви, и създайте нова парола.",
      verificationCode: "Код за Потвърждение",
      codeValidityTime: "Срок на валидност на кода",
      newPassword: "Нова Парола",
      newPasswordPlaceholder: "Въведете нова парола",
      confirmPassword: "Потвърждение на Парола",
      confirmPasswordPlaceholder: "Потвърдете паролата си",
      resettingPassword: "Нулиране на Парола...",
      resetPasswordButton: "Нулиране на Парола",
      enterVerificationCode: "Въведете 6-цифрения код за потвърждение.",
      passwordMinLength: "Паролата трябва да е поне 6 символа.",
      passwordMismatch: "Паролите не съвпадат!",
      passwordResetSuccess: "Паролата ви беше успешно нулирана!",
      passwordResetError: "Паролата не можа да бъде нулирана, моля опитайте отново.",
    },
  };